<div class="card mx-4">
	<div class="d-flex">
		<div class="h4 ms-1 mt-2 mb-1">Accept and Order</div>
	</div>
	<p-divider></p-divider>

	<div class="item-med">
		By inputing your information below and pressing <i>Submit Order</i> you hereby agree to the Focus POS of Arizona, LLC Master Subscription Agreement,
		Terms of Sale and New System Terms and Conditions.
	</div>

	<div class="item-med">
		The following agreements apply to your order. Please review prior to accepting this quote.
		<ul>
			<li>
				<a href="https://focusca.my.salesforce.com/sfc/p/#G0000000kkO8/a/4600000002rP/E0I19YCgoYPDbTwTw55OlWTYKWxTEjUT7czP2tIY6ys" target="_blank"
					>Focus POS of Arizona Master Subscription Agreement</a
				>
			</li>
			<li>
				<a href="https://focusca.my.salesforce.com/sfc/p/G0000000kkO8/a/4600000002tz/zYmFNfF728Vnw_ANrlZ.i7uN9NlX4Mvhbm0W90geYI4" target="_blank">
					Focus POS of Arizona General Terms & Conditions of Sale
				</a>
			</li>
			<li *ngIf="quoteService.quote.value.Opportunity.RecordTypeId === '01216000001BMocAAG'">New System Terms & Conditions (see above)</li>
			<li *ngIf="hasGift">
				<a href="https://focusca.my.salesforce.com/sfc/p/#G0000000kkO8/a/4A000000I7wo/XTu1cRmvgLFf1xpXH4vEUEQs5Do68R8L1i9ammAFN8w" target="_blank"
					>FocusGift/FocusRewards terms & conditions
				</a>
			</li>
			<li *ngIf="hasFocusProducts">
				<a href="https://focusca.my.salesforce.com/sfc/p/G0000000kkO8/a/4600000002rU/d858nnJ14PPqmQhPAAHyuq0NluNUmjRdmNb.BziILGE" target="_blank"
					>Focus End User License Agreement
				</a>
			</li>
			<li *ngIf="hasProfessionalServices">
				<a href="https://focusca.my.salesforce.com/sfc/p/G0000000kkO8/a/4600000002rZ/TM.ogVbM6dG3IIHHsh8.4xFuCasZHdzXKHmU6pFmRuA" target="_blank"
					>Helpdesk Service Agreement</a
				>
			</li>
		</ul>
	</div>

	<form #acceptanceForm="ngForm">
		<div class="d-flex flex-column">
			<div class="d-flex ms-4">
				<p-checkbox required="true" binary="true" name="termsAcceptanceAccept" [(ngModel)]="quoteAcceptance.termsAcceptance"></p-checkbox>
				<div class="item-med d-flex ms-3">
					I have reviewed the agreements that apply to my order and have reviewed the contract terms as noted above. I hereby agree to the contract
					terms. I further attest that I am a duly authorized representative of my company and am approved to enter into contractual agreements on
					behalf of my company.
				</div>
			</div>
			<div class="d-flex ms-4" *ngIf="quoteAcceptance.paymentTermsAcceptance">
				<p-checkbox required="true" binary="true" name="termsAcceptanceAccept" [(ngModel)]="quoteAcceptance.paymentTermsAcceptance"></p-checkbox>
				<div class="item-med d-flex ms-3">
					I have reviewed and understand the additional terms provided for my order: {{ quoteService.quote.value.PaymentTermNotes__c }}
				</div>
			</div>
		</div>

		<div class="p-grid">
			<div class="p-col-12 p-md-4">
				<div *ngIf="!quoteAcceptance.submitted">
					<span class="p-float-label mt-4">
						<input
							required="true"
							pInputText
							#acceptedByFirstNameInput
							name="acceptedByFirstNameInput"
							type="text"
							[(ngModel)]="quoteAcceptance.firstName"
							class="w-100"
						/>
						<label for="acceptedByFirstNameInput">First Name</label>
					</span>
				</div>
				<div *ngIf="quoteAcceptance.submitted">Accepted by: {{ quoteAcceptance.firstName }} {{ quoteAcceptance.lastName }}</div>
			</div>
			<div class="p-col-12 p-md-4">
				<div *ngIf="!quoteAcceptance.submitted">
					<span class="p-float-label mt-4">
						<input
							required="true"
							pInputText
							#acceptedByLasttNameInput
							name="acceptedByLasttNameInput"
							type="text"
							[(ngModel)]="quoteAcceptance.lastName"
							class="w-100"
						/>
						<label for="acceptedByLasttNameInput">Last Name</label>
					</span>
				</div>
			</div>
			<div class="p-col-12 p-md-4">
				<div *ngIf="!quoteAcceptance.submitted">
					<span class="p-float-label mt-4">
						<p-calendar required="true" name="acceptedDateTime" [(ngModel)]="quoteAcceptance.dateTimeSigned" styleClass="w-100"></p-calendar>
						<label for="acceptedByEmailInput">Accepted Date</label>
					</span>
				</div>
				<div *ngIf="quoteAcceptance.submitted">Accepted date: {{ app.moment(quoteAcceptance.dateTimeSigned).format("l LT") }}</div>
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-md-4">
				<div *ngIf="!quoteAcceptance.submitted">
					<span class="p-float-label mt-4">
						<input
							required="true"
							pInputText
							#acceptedByEmailInput
							name="acceptedByEmailInput"
							type="email"
							[(ngModel)]="quoteAcceptance.emailAddress"
							class="w-100"
						/>
						<label for="acceptedByEmailInput">Email Address</label>
					</span>
				</div>
				<div *ngIf="quoteAcceptance.submitted">Email address: {{ quoteAcceptance.emailAddress }}</div>
			</div>
			<div class="p-col-12 p-md-4">
				<div *ngIf="!quoteAcceptance.submitted">
					<span class="p-float-label mt-4">
						<input
							required="true"
							pInputText
							#acceptedByPhoneInput
							name="acceptedByPhoneInput"
							type="phone"
							[(ngModel)]="quoteAcceptance.phoneNumber"
							class="w-100"
						/>
						<label for="acceptedByPhoneInput">Phone number</label>
					</span>
				</div>
				<div *ngIf="quoteAcceptance.submitted">Phone number: {{ quoteAcceptance.phoneNumber }}</div>
			</div>
			<div class="p-col-12 p-md-4">
				<div *ngIf="!quoteAcceptance.submitted">
					<span class="p-float-label mt-4">
						<input
							required="true"
							pInputText
							#acceptedByTitleInput
							name="acceptedByTitleInput"
							type="text"
							[(ngModel)]="quoteAcceptance.title"
							class="w-100"
						/>
						<label for="acceptedByTitleInput">Title</label>
					</span>
				</div>
				<div *ngIf="quoteAcceptance.submitted">Accepted by persons title: {{ quoteAcceptance.title }}</div>
			</div>
		</div>
		<div class="p-grid" *ngIf="quoteAcceptance.submitted">
			<div class="p-col">Accepted by user IP Address: {{ quoteAcceptance.ipAddress }}</div>
		</div>
		<div class="d-flex w-100">
			<div class="mx-auto">
				<p-button
					[disabled]="acceptanceForm.invalid || !quoteAcceptance.termsAcceptance"
					pRipple
					styleClass="p-button-raised p-button-success my-2"
					(click)="submitOrder()"
				>
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['fad', 'check-double']" size="lg" class="ms-1 me-2"></fa-icon>
							Submit Order
						</div>
					</ng-template>
				</p-button>
			</div>
		</div>
	</form>
</div>
